import { getConfigValue } from 'src/utils/config/config'
import { getSurveyConfig } from '../../../plugins/survey/helper/survey.config'
import { NavigationFeatureFlags } from './model'

const surveyConfig = getSurveyConfig()

export const navigationFeatureFlags = new Map<NavigationFeatureFlags, boolean>([
  [NavigationFeatureFlags.CREATE_PROFILE, !!getConfigValue<boolean>('featureFlags.startMenu.createProfile')],
  [NavigationFeatureFlags.SURVEYS, surveyConfig.isEnabled]
])
